$(document).ready(function() {

    // Google Analytics
    var cookieName = 'ga-disable-' + $('body').data('analyticscode');

    // Abfrage, ob das Cookie für das deaktivierte Analytics gesetzt ist
    if (document.cookie.indexOf(cookieName + '=true') > -1) {
        // Abfrage, ob wir uns auf einer Seite mit dem NCE zum Deaktivieren befinden
        if ($(".ttgNCEAnalytics").length) {
            $('#ttgAnalyticsDeactivate').hide();
            $('#ttgAnalyticsSuccess').show();
        } // if
    }

    // Copyright bei Bildern
    $(document).on('click', 'button.ttgCopyrightIcon', function(e) {
        e.preventDefault();
        e.stopPropagation();
        $(this).hide();
        $(this).siblings('.ttgCopyrightText').show();
        $(this).siblings('.ttgCopyrightText').children('button').focus();
    });

    $(document).on('click', 'button.ttgCopyrightTextButton', function(e) {
        e.preventDefault();
        e.stopPropagation();
        $(this).parent('.ttgCopyrightText').hide();
        $(this).parent('.ttgCopyrightText').siblings('.ttgCopyrightIcon').show();
        $(this).parent('.ttgCopyrightText').siblings('.ttgCopyrightIcon').focus();
    });

    // Swipe-Funktionalität bei Carousel
    $(".carousel").swipe({
        swipe: function(event, direction, distance, duration, fingerCount, fingerData) {

            if (direction == 'left')
                $(this).carousel('next');
            if (direction == 'right')
                $(this).carousel('prev');

        },
        allowPageScroll: "vertical"
    });

    // Swipe-Funktionalität bei Carousel
    $(".carousel").on('slide.bs.carousel', function(e) {
        $(this).find('.carousel-indicators .active').removeAttr('aria-current');
    });
    $(".carousel").on('slid.bs.carousel', function() {
        $(this).find('.carousel-indicators .active').attr('aria-current', 'true');
    });


    // Testimonial: Carousel - Höhenanpassung
    if ($('.ttgNCETestimonial .carousel-item').length) {
        var testimonialCarouselIdentifier = '.ttgNCETestimonial .carousel-item';
        carouselNormalization(testimonialCarouselIdentifier);
    }

    // Bild-Text-Slider: Carousel - Höhenanpassung
    if ($('.ttgNCEBildTextSlider .carousel-item').length) {
        var bildtextCarouselIdentifier = '.ttgNCEBildTextSlider .carousel-item';
        carouselNormalization(bildtextCarouselIdentifier);
    }

    // NCE Countdown
    if ($('.ttgNCECountdown').length) {
        var countDownDate = new Date($("#finalDateTime").text()).getTime();
        var x = setInterval(function() {

            var now = new Date().getTime();
            var distance = countDownDate - now;
            var days = Math.floor(distance / (1000 * 60 * 60 * 24));
            var hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
            var minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
            var seconds = Math.floor((distance % (1000 * 60)) / 1000);

            //Klassen für 3 bzw. 4-stellige Ausgabe
            if (days > 999) {
                $(".ttgCountdownTimerPositioner").removeClass("ttgCountdownTimer2stellig").addClass("ttgCountdownTimer4stellig");
            } else if (days > 99) {
                $(".ttgCountdownTimerPositioner").removeClass("ttgCountdownTimer2stellig").addClass("ttgCountdownTimer3stellig");
            }

            //Output Result
            $(".ttgCountdownDays").text(days);
            $(".ttgCountdownHours").text(hours);
            $(".ttgCountdownMinutes").text(minutes);
            $(".ttgCountdownSeconds").text(seconds);
        }, 1000);
    }

    // NCE Video
    // Wenn NCE Video auf Seite und allen Cookies zugestimmt, binde YT API ein
    if ($('.ttgNCEVideo').length && !$('#yt-api').length) {
        if (getCookie('cookieConsented-analysis') == "1" && getCookie('cookieConsented-marketing') == "1" && getCookie('cookieConsented-personalization') == "1") {
            var tag = document.createElement('script');
            tag.id = "yt-api";
            tag.src = "https://www.youtube.com/iframe_api";
            var firstScriptTag = document.getElementsByTagName('script')[0];
            firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
        }

        // ELSE > YT API Einbindung nach Klick auf Play-Button in Consent Overlay
    }

    $('.ttgVideoPreview').each(function() {
        if (getCookie('cookieConsented-analysis') == "1" && getCookie('cookieConsented-marketing') == "1" && getCookie('cookieConsented-personalization') == "1") {
            if (!$(this).data("overlay")) {
                if ($(this).find("picture").length) {
                    $(this).find("picture").after('<div class="ttgVideoOverlay ttgVideoButtonPlayNoOverlay"><button class="ttgVideoButtonPlay" data-uid="' + $(this).data("uid") + '" data-youtubeId="' + $(this).data("youtubeid") + '" ><span class="fas fa-play" aria-hidden="true"></span> ' + $(this).data("playvideotext") + '</button></div>');
                } else {
                    $(this).append('<div class="ttgVideoContainerIframe"><iframe src="//www.youtube-nocookie.com/embed/' + $(this).data("youtubeid") + '?rel=0&showinfo=0&autohide=0&modestbranding=1&controls=1&wmode=transparent"></iframe></div>');
                }
            }
        } else {
            if (!$(this).data("overlay")) {
                if ($(this).find("picture").length) {
                    $(this).find("picture").after('<div id="ttgVideoOverlayOne' + $(this).data("uid") + '" class="ttgVideoOverlay ttgVideoOverlayOne"><p>' + $(this).data("consenttextone") + '</p><button class="ttgVideoButtonPlay" data-uid="' + $(this).data("uid") + '" data-youtubeId="' + $(this).data("youtubeid") + '"><span class="fas fa-play" aria-hidden="true"></span> ' + $(this).data("playvideotext") + '</button><p><a href="#" class="ttgVideoButtonDeny" data-uid="' + $(this).data("uid") + '">' + $(this).data("consentdeny") + '</a></p></div><div id="ttgVideoOverlayTwo' + $(this).data("uid") + '" class="ttgVideoOverlay" style="display: none"><p>' + $(this).data("consenttexttwo") + '</p><div class="ttgVideoButtonPlay"><a href="https://www.youtube.com/watch?v=' + $(this).data("youtubeid") + '" target="_blank"><span class="fas fa-play" aria-hidden="true"></span> ' + $(this).data("tovideotext") + '</a></div></div>');
                } else {
                    $(this).append('<div id="ttgVideoOverlayOne' + $(this).data("uid") + '" class="ttgVideoOverlay ttgVideoOverlayOne"><p>' + $(this).data("consenttextone") + '</p><button class="ttgVideoButtonPlay" data-uid="' + $(this).data("uid") + '" data-youtubeId="' + $(this).data("youtubeid") + '"><span class="fas fa-play" aria-hidden="true"></span> ' + $(this).data("playvideotext") + '</button><p><a href="#" class="ttgVideoButtonDeny" data-uid="' + $(this).data("uid") + '">' + $(this).data("consentdeny") + '</a></p></div><div id="ttgVideoOverlayTwo' + $(this).data("uid") + '" class="ttgVideoOverlay" style="display: none"><p>' + $(this).data("consenttexttwo") + '</p><div class="ttgVideoButtonPlay"><a href="https://www.youtube.com/watch?v=' + $(this).data("youtubeid") + '" target="_blank"><span class="fas fa-play" aria-hidden="true"></span> ' + $(this).data("tovideotext") + '</a></div></div>');
                }
            }
        }
    });

    $(".ttgVideoButtonPlay").click(function() {
        if ((getCookie('cookieConsented-analysis') == "0" || getCookie('cookieConsented-marketing') == "0" || getCookie('cookieConsented-personalization') == "0") && !$('#yt-api').length) {
            var tag = document.createElement('script');
            tag.id = "yt-api";
            tag.src = "https://www.youtube.com/iframe_api";
            var firstScriptTag = document.getElementsByTagName('script')[0];
            firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
        }

        var player;
        var uid = $(this).data("uid");
        var videoId = $(this).data("youtubeid");
        var height = $('.ttgVideoPreview' + uid + ' img').height();
        setTimeout(function() {
            player = new YT.Player('ttgVideoContainer' + uid, {
                host: 'https://www.youtube-nocookie.com',
                width: '100%',
                height: height,
                videoId: videoId,
                playerVars: {
                    'autoplay': 1,
                    'controls': 1,
                    'modestbranding': 1,
                    'iv_load_policy': 3,
                    'showinfo': 0,
                    'autohide': 1,
                    'enablejsapi': 1,
                    'rel': 0
                },
                events: {
                    'onReady': onPlayerReady,
                    'onStateChange': onPlayerStateChange
                }
            });

            /* Vorschaubild verstecken */
            $('.ttgVideoPreview' + uid).hide();
        }, 200);
    });

    $(".ttgVideoButtonDeny").click(function(e) {
        e.preventDefault();
        var uid = $(this).data("uid");

        $("#ttgVideoOverlayOne" + uid).hide();
        $("#ttgVideoOverlayTwo" + uid).show();
    });

});

$(window).on('load', function() {
    //NCE Bildergalerie
    if ($('.gallery').length) {
        $('.gallery').masonry({
            itemSelector: '.pics'
        });
        $('.gallery').masonry('layout');
    }
});

function onPlayerReady(event) {
    event.target.playVideo();
}

function onPlayerStateChange(event) {
    if (event.data == YT.PlayerState.ENDED) {
        player.destroy();
        $('.ttgVideoPreview' + uid).show();
    }
}

function normalizeHeights(items, heights, tallest) {
    items.each(function() { //add heights to array
        heights.push($(this).height());
    });
    tallest = Math.max.apply(null, heights); //cache largest value
    items.each(function() {
        $(this).css('min-height', tallest + 'px');
    });
}

function carouselNormalization(identifier) {
    windowWidth = $(window).width();

    if (windowWidth > 768) {
        var items = $(identifier), //grab all slides
            heights = [], //create empty array to store height values
            tallest; //create variable to make note of the tallest slide

        if (items.length) {

            normalizeHeights(items, heights, tallest);

            $(window).on('resize orientationchange', function() {
                tallest = 0;
                heights.length = 0; //reset vars
                items.each(function() {
                    $(this).css('min-height', '0'); //reset min-height
                });
                normalizeHeights(items, heights, tallest); //run it again
            });
        }
    }
}
